import * as currencyBoard from './currencyBoard/actions';
import * as currencyConverter from './currencyConverter/actions';
import * as login from './login/actions';
import * as mainBoard from './mainBoard/actions';
import * as productManage from './productManage/actions';
import * as register from './register/actions';
import * as surveyManage from './surveyManage/actions';
import * as worldClock from './worldClock/actions';
import * as news from './news/actions';
import * as eventSlider from './eventSlider/actions';

export const organismActions = {
	//
	currencyBoard,
	eventSlider,
	currencyConverter,
	login,
	mainBoard,
	productManage,
	register,
	surveyManage,
	worldClock,
	news,
};
